import script from "./Page18.vue?vue&type=script&setup=true&lang=js"
export * from "./Page18.vue?vue&type=script&setup=true&lang=js"

import "./Page18.vue?vue&type=style&index=0&id=3e164667&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e164667"]])

export default __exports__